<div style="position: absolute;left: 50%;">
    <div *ngIf="alertService.show==true" class={{alertService.class}} style="position: relative; left: -50%; padding: 5px;border-radius: 10px;z-index: 10000;"
        role="alert">
        <h4 *ngIf="alertService.title!=null && alertService.title.lenght>0" class="alert-heading" style="margin: 0">{{alertService.title}}</h4>
        <p *ngFor="let descrip of alertService.description" style="margin: 0; padding-right: 20px;">{{descrip}}</p>
        <button *ngIf="alertService.isDismissible==true" type="button" class="close" style="position: absolute;top: 0;right: 5px; padding: 0;" aria-label="Close"
            (click)="alertService.closeAlert()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>